import React, { useState, useContext, useEffect } from "react";
import ShopButton from "./ShopButton";
import { useNavigate } from "react-router-dom";
import { useFirestore } from "../firebase/FirestoreContext";
import { collection, getDocs } from "firebase/firestore";
import { EnvContext } from "../context/EnvContext";
import config from "../config";
import HorizontalScroll from "./HorizontalScroll";
import cdn from "../utils/cdn";

const breakpoints = [390, 520, 755]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

const CategoryBrowse = ({ containerStyle, numColumns, shopButton = true, title = true, toggleMenu, scrollable }) => {
  const navigate = useNavigate();
  const [sortedCategories, setSortedCategories] = useState([]);
  const db = useFirestore();
  const environment = useContext(EnvContext);
  const collectionPath = environment === "staging" ? config.environment.staging.collectionPath : config.environment.production.collectionPath;

  const gridLayout = {
    display: "grid",
    gridTemplateColumns: `repeat(${numColumns || '2'}, minmax(${numColumns > 2 ? '86px' : '115px'}, 1fr))`,
    gap: "10px",
    [mq[0]]: {
      gridTemplateColumns: `repeat(${numColumns || '3'}, minmax(${numColumns > 2 ? '86px' : '115px'}, 1fr))`,
    },
    [mq[2]]: {
      gridTemplateColumns: `repeat(${numColumns || '6'}, minmax(110px, 1fr))`,
      gap: numColumns > 3 ? '20px' : '10px',
    },
    marginBottom: scrollable ? "5px" : ""
  }

  useEffect(() => {
    const fetchCategories = async () => {
      if (!db) {
        console.error("Firestore instance is not initialized.");
        return;
      }
      try {
        const categoryCollection = collection(db, `${collectionPath}SooperstockSettings/ProductCategories/DataBase`);
        const categorySnapshot = await getDocs(categoryCollection);
        const categoryList = categorySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

        // Sort categories by order
        const sorted = [...categoryList].sort((a, b) => a.order - b.order);
        setSortedCategories(sorted);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, [db, collectionPath]);

  return (
    <div css={containerStyle}>
      <div css={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        {title && <div css={styles.title}>Browse by Category</div>}
      </div>

      {/* Grid Layout */}
      <HorizontalScroll>
        <div css={gridLayout}>
          {sortedCategories.map((category) => {
            if (!category.display_on_list) return null;
            return (
              <div key={category.id}
                css={styles.category.card}
                onClick={() => {
                  navigate(`/product-category/${category.categoryName}`);
                  toggleMenu?.();
                }}
              >
                <div css={{
                  ...styles.category.imageContainer,
                  height: `${numColumns && numColumns <= 2 ? "115px" : "86px"}`,
                  [mq[1]]: {
                    height: `${numColumns <= 2 ? "115px" : "145px"}`,
                  },
                }}>
                  {category?.image_url && <img src={cdn.image(category.image_url, { h: 290 })} alt={category.name} css={styles.category.image} />}
                </div>
                <span css={styles.category.title}>{category.name}</span>
              </div>
            );
          })}
        </div>
      </HorizontalScroll>

      {/* Shop All Button */}
      {shopButton && (
        <div css={{ padding: "0 10px" }}>
          <ShopButton containerStyles={styles.shop.button}
            buttonStyle={styles.shop.text} text="Shop All" theme="dark" onClick={() => navigate("/shop")} arrow={true} />
        </div>
      )}
    </div>
  );
};

const styles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  title: {
    color: "black",
    fontSize: "1.4rem",
    fontWeight: 700,
    paddingLeft: "5px",
    paddingBottom: "12px",
    [mq[2]]: {
      fontSize: "1.75rem",
    },
  },
  seeAllButton: {
    fontSize: "1rem",
    cursor: "pointer",
    background: "none",
    border: "none",
    color: "black",
    fontWeight: 600,
  },
  category: {
    card: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "0px",
      cursor: "pointer",
      minWidth: "86px",
      [mq[1]]: {
        height: "145px",
      },
    },
    imageContainer: {
      backgroundColor: "#f5f5f5",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      borderRadius: "10px",
      overflow: "hidden",
      padding: "10px",
      [mq[1]]: {
        height: "145px",
      },
    },
    image: {
      width: "100%",
      height: "100%",
      objectFit: "contain",
    },
    title: {
      paddingTop: "5px",
      fontSize: "1rem",
      fontWeight: 500,
    },
  },
  text: {
    fontSize: "1rem",
    fontWeight: 700,
  },
  backButtonContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  backButtonText: {
    fontSize: "1rem",
    fontWeight: "600",
    color: "#1E1E1E",
    marginRight: "5px",
  },
  backButton: {
    display: "flex",
    width: "28px",
    height: "28px",
    borderRadius: "28px",
    justifyContent: "center",
    alignItems: "center",
    border: "2px solid black",
    flexDirection: "row",
  },
  shop: {
    button: {
      maxWidth: "380px",
      margin: "10px auto",
    },
    text: {
      fontSize: "1rem",
      lineHeight: "1rem",
      [mq[0]]: {
        fontSize: "1.25rem",
        lineHeight: "1.25rem",
      },
      [mq[2]]: {
        fontSize: "1.5rem",
        lineHeight: "1.5rem",
      }
    }
  }
};

export default CategoryBrowse;
